class StickyAddToCart extends HTMLElement {
  getStickyHeaderOffset = () => {
    if (!this.stickyHeader) {
      return 0;
    }

    return this.stickyHeader.offsetHeight;
  };

  constructor() {
    super();
    this.stickyHeader = document.getElementById("SiteHeader");
    this.createSticky();
  }

  createSticky() {
    const mobileButton = this.querySelector("[data-add-to-cart]");
    const footerElement = document.querySelector(".site-footer");
    const stickyHeaderOffset = this.getStickyHeaderOffset();
    const mq = window.matchMedia("(max-width: 767px)");
    setTimeout(() => {
      this.style.setProperty("--Button_Height", `${this.offsetHeight}px`);
    }, 1000);

    if (!mobileButton || !mq.matches) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.target === footerElement) {
            this._isFooterVisible = entry.intersectionRatio > 0;
          }
          if (entry.target === mobileButton) {
            const boundingRect = mobileButton.getBoundingClientRect();
            this.isformButtonPassed =
              entry.intersectionRatio === 0 &&
              boundingRect.top + boundingRect.height <= stickyHeaderOffset;
          }

          if (!this._isFooterVisible) {
            mobileButton.parentElement.classList.remove(
              "product-single__form-button--hidden"
            );
            mobileButton.parentElement.ariaHidden = false;
          } else {
            mobileButton.parentElement.classList.add(
              "product-single__form-button--hidden"
            );
            mobileButton.parentElement.ariaHidden = true;
          }
        }
      },
      { rootMargin: `-${stickyHeaderOffset}px 0px 0px 0px` }
    );
    observer.observe(footerElement);
  }
}

if (!customElements.get("sticky-form")) {
  customElements.define("sticky-form", StickyAddToCart);
}
